import { render, staticRenderFns } from "./inscripciones-evento.vue?vue&type=template&id=7467b440&"
import script from "./inscripciones-evento.vue?vue&type=script&lang=js&"
export * from "./inscripciones-evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports